namespace advisorop.components.servicer {

    // Maintenance widget: grid of all households with a per-row "Delete" (retire) action.
    // Delete is only enabled when the household has no active accounts (only closed/canceled
    // accounts are allowed). The retire itself is enforced + guarded server-side.
    class AdminHouseholdGridController {

        public households: Array<domains.IAdminHouseholdRow> = [];
        public dg: DevExpress.ui.dxDataGridOptions;
        public dataGrid: DevExpress.ui.dxDataGrid;
        public loading: boolean = false;
        public retiring: boolean = false;

        static $inject = ["servicerService"];
        constructor(private servicerService: services.ServicerService) {

            this.dg = {
                bindingOptions: {
                    dataSource: "vm.households"
                },
                onInitialized: (e) => {
                    this.dataGrid = e.component;
                },
                keyExpr: "id",
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                rowAlternationEnabled: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                wordWrapEnabled: true,
                noDataText: "No households",
                filterRow: { visible: true },
                headerFilter: { visible: true },
                searchPanel: { visible: true, width: 260, placeholder: "Search..." },
                paging: { pageSize: 25 },
                pager: {
                    showPageSizeSelector: true,
                    allowedPageSizes: [25, 50, 100],
                    showInfo: true
                },
                columns: [
                    { dataField: "name", caption: "Household" },
                    { dataField: "advisorsStr", caption: "Advisor(s)" },
                    { dataField: "statusDescription", caption: "Status", width: 110 },
                    { dataField: "investorCount", caption: "# Investors", dataType: "number", width: 100 },
                    { dataField: "activeAccountCount", caption: "# Active Accts", dataType: "number", width: 120 },
                    { dataField: "closedCanceledAccountCount", caption: "# Closed/Canceled", dataType: "number", width: 150 },
                    { dataField: "canDelete", caption: "Deletable", dataType: "boolean", width: 90 },
                    { caption: "", cellTemplate: "btnDelete", width: 90, allowFiltering: false, allowSorting: false }
                ]
            };
        }

        $onInit(): void {
            this.loadHouseholds();
        }

        loadHouseholds(): void {
            this.loading = true;
            this.servicerService.getHouseholdsForAdminMaintenance()
                .then(response => {
                    this.households = response.data;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                    toastr.error("Failed to load households" + (err && err.status ? " (" + err.status + ")" : ""));
                });
        }

        retire(row: domains.IAdminHouseholdRow): void {
            if (!row || !row.canDelete) {
                toastr.warning("This household has active accounts and cannot be deleted.");
                return;
            }

            var msg = "Retire (delete) household \"" + row.name + "\" (#" + row.id + ")?\n\n"
                + "This will:\n"
                + "  - mark the household EXPIRED\n"
                + "  - remove its investor links\n"
                + "  - retire its account groups and Orion mapping\n\n"
                + "Only closed/canceled accounts are allowed. Continue?";

            if (!window.confirm(msg))
                return;

            this.retiring = true;
            this.servicerService.retireHousehold(row.id)
                .then(response => {
                    this.retiring = false;
                    toastr.success((response.data && response.data.message) ? response.data.message : "Household retired.");
                    this.loadHouseholds();
                })
                .catch(err => {
                    this.retiring = false;
                    var errMsg = (err && err.data) ? err.data : "Retire failed";
                    toastr.error(errMsg + (err && err.status ? " (" + err.status + ")" : ""));
                });
        }
    }

    class AdminHouseholdGrid implements ng.IComponentOptions {

        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.controller = AdminHouseholdGridController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/admin-household-grid.html';
        }
    }
    angular.module(Constants.APP).component("adminHouseholdGrid", new AdminHouseholdGrid());
}
